/* eslint-disable */
import { Component } from 'react';
import PropTypes from 'prop-types';

export default class PermissionComponent extends Component {
    static contextTypes = {
        user: PropTypes.object,
    };

    renderIfPerm(node) {
        if (this.props.show === false) {
            return null;
        }
        if (!this.context.user) {
            return node;
        }
        const permConditionMet =
            !this.props.requiredPermission ||
            (this.props.requiredPermission[0] === '!' &&
                this.context.user.permissions.indexOf(
                    this.props.requiredPermission.slice(1),
                ) == -1) ||
            (this.props.requiredPermission[0] !== '!' &&
                this.context.user.permissions.indexOf(
                    this.props.requiredPermission,
                ) > -1);
        const roleConditionMet =
            !this.props.requiredRole ||
            this.context.user.userType === this.props.requiredRole;
        const featureConditionMet =
            !this.props.requiredFeature ||
            (this.context.user.agency &&
                this.context.user.agency.features.indexOf(
                    this.props.requiredFeature,
                ) > -1);
        const booleanLogic = this.props.booleanLogic || 'and';
        if (
            (booleanLogic == 'or' &&
                (permConditionMet ||
                    roleConditionMet ||
                    featureConditionMet)) ||
            (booleanLogic == 'and' &&
                permConditionMet &&
                roleConditionMet &&
                featureConditionMet)
        ) {
            return node;
        }
        return null;
    }
}
